import { COURSES } from '../data/academyCourses'
import { INTERESTS } from '../data/academyCommunity'
import type { InterestId } from '../types/academyHub'

/** Courses matching the learner's interests first, then the flagship, skipping anything already enrolled. */
export function recommendCourses(interests: InterestId[], enrolments: Record<string, string>, count: number): string[] {
  const scores = new Map<string, number>()
  for (const id of interests) {
    const interest = INTERESTS.find((i) => i.id === id)
    interest?.courses.forEach((slug, rank) => scores.set(slug, (scores.get(slug) ?? 0) + (3 - Math.min(rank, 2))))
  }
  const flagship = COURSES.find((c) => c.flagship)?.slug
  return COURSES.map((c) => c.slug)
    .filter((slug) => !enrolments[slug])
    .sort((a, b) => (scores.get(b) ?? 0) - (scores.get(a) ?? 0) || Number(b === flagship) - Number(a === flagship))
    .slice(0, count)
}
